import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import * as React from "react";
import ReactTooltip from "react-tooltip";
import {
    defaultTooltipStyle,
} from "source/app/presentation/Shared/DisplayTooltipsContainer/DisplayTooltipsContainer";
import * as tooltipStyles from "source/app/presentation/Shared/DisplayTooltipsContainer/DisplayTooltipsContainer.css";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { DeleteNode } from "../../RootNodeNameTools/DeleteNode/DeleteNode";
import { SelectNodes } from "../../RootNodeNameTools/SelectNodes/SelectNodes";
import { ToggleFavorite } from "../../RootNodeNameTools/ToggleFavorite/ToggleFavorite";
import * as styles from "./WorkflowNodeActionsTool.css";

export function WorkflowNodeActionsTool({
    rootNode,
    selectedNodeCount,
    isMultiSelectMode,
}: {
    rootNode: IWorkflowNode;
    selectedNodeCount: number;
    isMultiSelectMode: boolean;
}) {
    const [isOpen, setIsOpen] = React.useState(false);
    const toolRef = React.useRef<HTMLSpanElement>(null);

    React.useEffect(() => {
        setIsOpen(false);
    }, [rootNode.id]);

    React.useEffect(() => {
        ReactTooltip.hide();
        ReactTooltip.rebuild();
    }, [isOpen]);

    React.useEffect(() => {
        const closeOnOutsideClick = (event: MouseEvent) => {
            if (!toolRef.current?.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", closeOnOutsideClick);
        return () =>
            document.removeEventListener("mousedown", closeOnOutsideClick);
    }, []);

    return (
        <span
            ref={toolRef}
            className={styles.tool}
            data-floating-tool-open={isOpen}
        >
            <span
                data-tip={isOpen ? undefined : "Workflow options"}
                data-for="workflowNodeActionsTooltip"
            >
                <IconWithText
                    iconSuffix={EGlyphicon.cog}
                    whenClicked={() => setIsOpen((current) => !current)}
                    displayAsBlock={false}
                />
            </span>
            <ReactTooltip
                id="workflowNodeActionsTooltip"
                delayHide={0}
                class={`${tooltipStyles.tooltipFrame} ${StyleClass(
                    "workflowNodeActionsTooltip",
                    defaultTooltipStyle
                )}`}
            />
            {isOpen ? (
                <span className={styles.submenu}>
                    <span
                        className={styles.subAction}
                        onClick={ActivateSubAction}
                        data-tip={
                            selectedNodeCount > 0
                                ? `Delete ${selectedNodeCount} selected`
                                : "Delete"
                        }
                    >
                        <DeleteNode
                            compact
                            rootNode={rootNode}
                            selectedNodeCount={selectedNodeCount}
                        />
                    </span>
                    <span
                        className={styles.subAction}
                        data-tip="Favorite"
                        onClick={ActivateSubAction}
                    >
                        <ToggleFavorite compact rootNode={rootNode} />
                    </span>
                    <span
                        className={styles.subAction}
                        onClick={ActivateSubAction}
                        data-tip="Select multiple"
                    >
                        <SelectNodes
                            compact
                            isMultiSelectMode={isMultiSelectMode}
                        />
                    </span>
                </span>
            ) : null}
        </span>
    );
}

function ActivateSubAction(event: React.MouseEvent<HTMLSpanElement>) {
    event.stopPropagation();

    const target = event.target as HTMLElement;

    if (target.closest("a, button, input, select, textarea")) {
        return;
    }

    event.currentTarget.querySelector<HTMLElement>("a, button")?.click();
}
